import { authFetch } from '../../auth/authFetch';
import { getApiBaseUrl } from '../../auth/api';
import type { ApiResponse, OrgDetailsDto, UpdateOrgRequestDto } from './organisationApiTypes';

const base = () => `${getApiBaseUrl()}/api/organisation`;

const parseOrThrow = async <T>(response: Response): Promise<ApiResponse<T>> => {
  if (!response.ok) throw new Error(`Request failed: ${response.status}`);
  return response.json() as Promise<ApiResponse<T>>;
};

export const fetchOrganisations = async (): Promise<ApiResponse<OrgDetailsDto[]>> => {
  const res = await authFetch(base());
  return parseOrThrow<OrgDetailsDto[]>(res);
};

export const fetchOrganisationById = async (orgId: string): Promise<ApiResponse<OrgDetailsDto>> => {
  const res = await authFetch(`${base()}/${orgId}`);
  return parseOrThrow<OrgDetailsDto>(res);
};

export const updateOrganisation = async (request: UpdateOrgRequestDto): Promise<ApiResponse<OrgDetailsDto>> => {
  const res = await authFetch(base(), {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request),
  });
  return parseOrThrow<OrgDetailsDto>(res);
};
